export const PROFILE_UPDATE_REQUEST = 'PROFILE/PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE/PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAILURE = 'PROFILE/PROFILE_UPDATE_FAILURE';

export const PROFILE_RESET_UPDATED = 'PROFILE/PROFILE_RESET_UPDATED';


// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Profile/constants.js